import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {CustomerFeatureTypeEnum} from 'src/app/enums/AdEnums';
import {ToolsService} from '../../../services/tools.service';
import {CustomerFeature} from '../../../types/CustomerFeature';
import {EventActionEnum, EventCategoryEnum} from '../../../enums/GaTrackingEnums';
import {AppConfigService} from '../../../services/app-config.service';
import {DLPageTypeEnum} from '../../../enums/DataLayerEnums';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {SharedTrackingModule} from '../../../app-common/shared-tracking.module';
import {UiButtonComponent} from '../../ui/ui-button/ui-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, SharedTrackingModule, UiButtonComponent],
  selector: 'app-customer-feature',
  templateUrl: './customer-feature.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerFeatureComponent {
  public feature = input<CustomerFeature>(null);
  public label = input<string>(null);
  public isCustomer = input<boolean>(false);
  public index = input<number>(null);
  public size = input<'xs' | 'sm' | 'md' | 'lg'>('md');
  public pageType = input<DLPageTypeEnum>(null);
  public color = input<
    | 'primary'
    | 'baba'
    | 'secondary'
    | 'tertiary'
    | 'green'
    | 'lightgreen'
    | 'apricot'
    | 'flat'
    | 'ghost'
    | 'outline'
    | 'outline-green'
    | 'outline-tertiary-green'
    | 'outline-tertiary'
  >('green');

  public imgUrl = computed<string>(() =>
    this.feature() && this.feature().imgUrl
      ? this.appConfigService.appConfig.amazonS3Url + this.feature().imgUrl
      : null,
  );
  public customerFeatureTypeEnum = CustomerFeatureTypeEnum;
  public eventCategoryEnum = EventCategoryEnum;
  public eventActionEnum = EventActionEnum;
  public btnClass = computed<string>(() =>
    !this.tools.isNil(this.index()) ? `test-customer-feature-${this.index()}` : `test-customer-feature`,
  );

  public appStoreImgUrl = computed<string>(() =>
    !this.tools.isNil(this.feature()?.imgUrl) && this.feature()?.imgUrl !== ''
      ? this.feature()?.imgUrl
      : this.appConfigService.appConfig.amazonS3Url + 'assets/app-store.webp',
  );
  public googlePlayImgUrl = computed<string>(() =>
    !this.tools.isNil(this.feature()?.imgUrl) && this.feature()?.imgUrl !== ''
      ? this.feature()?.imgUrl
      : this.appConfigService.appConfig.amazonS3Url + 'assets/google-play.webp',
  );

  // it is temporary solution - it's basic link lista dig, but callToAction is from new scraper flow
  // it is just to keep tracking in GTM working
  public listaDigSimpleLinkCallToAction: string = `${EventCategoryEnum.LISTA_DIG_DIRECT} - ${EventActionEnum.LISTA_DIG_VARDEN_DIRECT}`;

  constructor(
    private tools: ToolsService,
    private appConfigService: AppConfigService,
  ) {}
}
